import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .Document {
    &__message {
      text-align: center;
      padding: rem(20px);
      font-size: rem(14px);
      color: #999;
    }

    &__section {
      margin-bottom: rem(20px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .ContactPageInfoBlock__TitleWrap {
        flex-shrink: 0;
        min-width: 200px;
        display: flex;
        align-items: center;
      }
      
      .ContactPageInfoBlock__ItemTitle {
        display: block;
        color: #999;
      }
    }

    &__small-images-wrap {
      flex: 0 0 40%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-left: 20px;
    }

    &__small-images {
      display: flex;
      flex-wrap: wrap;
      gap: rem(10px);
      justify-content: flex-end;

      @include respond-to(sm) {
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }
`;

export { staticStyles };
